import { useState } from 'react';

export default function SearchSection() {
  const [searchData, setSearchData] = useState({
    location: '',
    propertyType: 'all',
    beds: '0',
    baths: '0',
    minPrice: '0',
    maxPrice: '100000000',
    minSqft: '',
    maxSqft: '',
    yearBuilt: '',
    lotSize: ''
  });

  const [showMoreOptions, setShowMoreOptions] = useState(false);

  const handleSearch = () => {
    const searchUrl = `https://jefferylong.exprealty.com/index.php?advanced=1&display=${searchData.location}&custombox=&types[]=1&types[]=2&types[]=4&types[]=8&types[]=9&types[]=15&types[]=18&types[]=31&types[]=32&types[]=5&types[]=20&beds=${searchData.beds}&baths=${searchData.baths}&min=${searchData.minPrice}&max=${searchData.maxPrice}&rtype=map#rslt`;
    window.open(searchUrl, '_blank');
  };

  return (
    <section className="bg-white py-8 shadow-sm">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <form className="grid grid-cols-1 md:grid-cols-6 gap-4 items-end">
            {/* Location */}
            <div className="md:col-span-2">
              <label htmlFor="location" className="block text-sm font-medium text-gray-700 mb-1">
                Location
              </label>
              <input
                id="location"
                type="text"
                placeholder="City, Area, Zip, MLS# , or Addr"
                value={searchData.location}
                onChange={(e) => setSearchData({...searchData, location: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm"
              />
            </div>

            {/* Property Type */}
            <div>
              <label htmlFor="propertyType" className="block text-sm font-medium text-gray-700 mb-1">
                Type
              </label>
              <select
                id="propertyType"
                value={searchData.propertyType}
                onChange={(e) => setSearchData({...searchData, propertyType: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm pr-8"
              >
                <option value="all">All Types</option>
                <option value="1">Single Family</option>
                <option value="2">Condos</option>
                <option value="4">Commercial</option>
                <option value="8">Mobile Home</option>
                <option value="5">Land</option>
              </select>
            </div>

            {/* Beds */}
            <div>
              <label htmlFor="beds" className="block text-sm font-medium text-gray-700 mb-1">
                Beds
              </label>
              <select
                id="beds"
                value={searchData.beds}
                onChange={(e) => setSearchData({...searchData, beds: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm pr-8"
              >
                <option value="0">Any</option>
                <option value="1">1+</option>
                <option value="2">2+</option>
                <option value="3">3+</option>
                <option value="4">4+</option>
                <option value="5">5+</option>
              </select>
            </div>

            {/* Baths */}
            <div>
              <label htmlFor="baths" className="block text-sm font-medium text-gray-700 mb-1">
                Baths
              </label>
              <select
                id="baths"
                value={searchData.baths}
                onChange={(e) => setSearchData({...searchData, baths: e.target.value})}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm pr-8"
              >
                <option value="0">Any</option>
                <option value="1">1+</option>
                <option value="1.5">1.5+</option>
                <option value="2">2+</option>
                <option value="2.5">2.5+</option>
                <option value="3">3+</option>
                <option value="4">4+</option>
              </select>
            </div>

            {/* Search Button */}
            <div>
              <button
                type="button"
                onClick={handleSearch}
                className="w-full bg-blue-600 text-white px-6 py-2 rounded-md hover:bg-blue-700 transition-colors font-medium whitespace-nowrap"
              >
                Search
              </button>
            </div>
          </form>

          {/* More Options */}
          <div className="text-center mt-4">
            <button 
              type="button"
              onClick={() => setShowMoreOptions(!showMoreOptions)}
              className="text-blue-600 hover:text-blue-700 text-sm font-medium cursor-pointer"
            >
              More Options <i className={`fa fa-chevron-${showMoreOptions ? 'up' : 'down'} ml-1`}></i>
            </button>
          </div>

          {/* Advanced Options Panel */}
          {showMoreOptions && (
            <div className="mt-4 p-4 bg-gray-50 rounded-lg border border-gray-200">
              <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                {/* Price Range */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Min Price
                  </label>
                  <select
                    value={searchData.minPrice}
                    onChange={(e) => setSearchData({...searchData, minPrice: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm pr-8"
                  >
                    <option value="0">No Min</option>
                    <option value="100000">$100,000</option>
                    <option value="200000">$200,000</option>
                    <option value="300000">$300,000</option>
                    <option value="400000">$400,000</option>
                    <option value="500000">$500,000</option>
                    <option value="750000">$750,000</option>
                    <option value="1000000">$1,000,000</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Max Price
                  </label>
                  <select
                    value={searchData.maxPrice}
                    onChange={(e) => setSearchData({...searchData, maxPrice: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm pr-8"
                  >
                    <option value="100000000">No Max</option>
                    <option value="200000">$200,000</option>
                    <option value="300000">$300,000</option>
                    <option value="400000">$400,000</option>
                    <option value="500000">$500,000</option>
                    <option value="750000">$750,000</option>
                    <option value="1000000">$1,000,000</option>
                    <option value="2000000">$2,000,000</option>
                    <option value="5000000">$5,000,000</option>
                  </select>
                </div>

                {/* Square Footage */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Min Sq Ft
                  </label>
                  <select
                    value={searchData.minSqft}
                    onChange={(e) => setSearchData({...searchData, minSqft: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm pr-8"
                  >
                    <option value="">No Min</option>
                    <option value="500">500 sq ft</option>
                    <option value="1000">1,000 sq ft</option>
                    <option value="1500">1,500 sq ft</option>
                    <option value="2000">2,000 sq ft</option>
                    <option value="2500">2,500 sq ft</option>
                    <option value="3000">3,000 sq ft</option>
                    <option value="4000">4,000 sq ft</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Max Sq Ft
                  </label>
                  <select
                    value={searchData.maxSqft}
                    onChange={(e) => setSearchData({...searchData, maxSqft: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm pr-8"
                  >
                    <option value="">No Max</option>
                    <option value="1000">1,000 sq ft</option>
                    <option value="1500">1,500 sq ft</option>
                    <option value="2000">2,000 sq ft</option>
                    <option value="2500">2,500 sq ft</option>
                    <option value="3000">3,000 sq ft</option>
                    <option value="4000">4,000 sq ft</option>
                    <option value="5000">5,000+ sq ft</option>
                  </select>
                </div>

                {/* Year Built */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Year Built
                  </label>
                  <select
                    value={searchData.yearBuilt}
                    onChange={(e) => setSearchData({...searchData, yearBuilt: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm pr-8"
                  >
                    <option value="">Any</option>
                    <option value="2020">2020+</option>
                    <option value="2010">2010+</option>
                    <option value="2000">2000+</option>
                    <option value="1990">1990+</option>
                    <option value="1980">1980+</option>
                    <option value="1970">1970+</option>
                  </select>
                </div>

                {/* Lot Size */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Lot Size
                  </label>
                  <select
                    value={searchData.lotSize}
                    onChange={(e) => setSearchData({...searchData, lotSize: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm pr-8"
                  >
                    <option value="">Any</option>
                    <option value="0.25">0.25+ acres</option>
                    <option value="0.5">0.5+ acres</option>
                    <option value="1">1+ acres</option>
                    <option value="2">2+ acres</option>
                    <option value="5">5+ acres</option>
                    <option value="10">10+ acres</option>
                  </select>
                </div>

                {/* Reset Button */}
                <div className="md:col-span-2 flex items-end">
                  <button
                    type="button"
                    onClick={() => setSearchData({
                      location: '',
                      propertyType: 'all',
                      beds: '0',
                      baths: '0',
                      minPrice: '0',
                      maxPrice: '100000000',
                      minSqft: '',
                      maxSqft: '',
                      yearBuilt: '',
                      lotSize: ''
                    })}
                    className="text-gray-600 hover:text-gray-800 text-sm font-medium cursor-pointer"
                  >
                    <i className="ri-refresh-line mr-1"></i> Reset Filters
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Information Bar */}
      <div className="bg-blue-50 py-4 mt-8">
        <div className="container mx-auto px-4 text-center">
          <h5 className="text-lg font-medium text-gray-800">
            40 Years in Real Estate. Let my team support your journey.
          </h5>
        </div>
      </div>
    </section>
  );
}